(function() {
  if (window.ShippingProgressScriptLoaded) {
    if (typeof window.ShippingProgressCheckCart === 'function') {
      window.ShippingProgressCheckCart();
    }
    return;
  }
  window.ShippingProgressScriptLoaded = true;

  var META1 = 600;
  var META2 = 1200;
  var GIFT_HANDLE = 'sacola-de-linho-lili';
  var GIFT_PRODUCT_ID = 7785311305811;
  var _giftVariantId = null;
  var _giftBusy = false;
  var _debounceTimer = null;
  var _pendingCheck = false;
  var _originalFetch = window.fetch ? window.fetch.bind(window) : null;
  var _lastRequestTime = 0;
  var _requestCount = 0;
  var _maxRequestsPerMinute = 30;

  function formatBRL(value) {
    return value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function getGiftVariantId() {
    if (_giftVariantId) return Promise.resolve(_giftVariantId);
    if (!_originalFetch) return Promise.resolve(null);
    return _originalFetch('/products/' + GIFT_HANDLE + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (product.variants && product.variants.length > 0) {
          _giftVariantId = product.variants[0].id;
        }
        return _giftVariantId;
      })
      .catch(function() { return null; });
  }

  function findGiftInCart(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === GIFT_PRODUCT_ID) {
        return cart.items[i];
      }
    }
    return null;
  }

  function cartTotalWithoutGift(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id !== GIFT_PRODUCT_ID) {
        total += cart.items[i].final_line_price;
      }
    }
    return total;
  }

  function addGiftToCart(variantId) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { '_brinde_automatico': 'true' } }]
      })
    }).then(function(r) { return r.json(); });
  }

  function isAutomaticGift(item) {
    var isAuto = item.properties && item.properties._brinde_automatico === 'true';
    console.log('[ShippingProgress] Checking if gift is automatic:', {
      item: item,
      properties: item.properties,
      _brinde_automatico: item.properties ? item.properties._brinde_automatico : 'not found',
      isAutomatic: isAuto
    });
    return isAuto;
  }

  function convertToAutomaticGift(lineKey, currentQuantity) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: lineKey, 
        quantity: currentQuantity,
        properties: { '_brinde_automatico': 'true' }
      })
    }).then(function(r) { return r.json(); });
  }

  function removeGiftFromCart(lineKey) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function setGiftQuantityTo1(lineKey) {
    if (!_originalFetch) return Promise.resolve();
    return _originalFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 1 })
    }).then(function(r) { return r.json(); });
  }

  function reloadCartSections() {
    if (!_originalFetch) return Promise.resolve();
    var cartDrawer = document.querySelector('cart-drawer');
    var sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : null;
    if (!sectionId) { 
      console.log('[ShippingProgress] No section ID found, reloading page');
      location.reload(); 
      return Promise.resolve(); 
    }

    console.log('[ShippingProgress] Reloading sections:', sectionId);
    return _originalFetch(window.location.pathname + '?sections=' + sectionId + ',cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        console.log('[ShippingProgress] Sections loaded:', Object.keys(sections));
        
        if (cartDrawer && sections[sectionId]) {
          var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');

          // Update the entire cart drawer contents
          var newDrawer = doc.querySelector('cart-drawer');
          var oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) {
            console.log('[ShippingProgress] Updating entire cart drawer');
            
            // Update cart items
            var newCartItems = newDrawer.querySelector('#CartDrawer-CartItems');
            var oldCartItems = oldDrawer.querySelector('#CartDrawer-CartItems');
            if (newCartItems && oldCartItems) {
              oldCartItems.innerHTML = newCartItems.innerHTML;
              console.log('[ShippingProgress] Cart items updated');
            }

            // Update footer
            var newFooter = newDrawer.querySelector('.drawer__footer-bottom');
            var oldFooter = oldDrawer.querySelector('.drawer__footer-bottom');
            if (newFooter && oldFooter) {
              oldFooter.innerHTML = newFooter.innerHTML;
              console.log('[ShippingProgress] Footer updated');
            }

            // Update cart count in drawer
            var newCount = newDrawer.querySelector('.cart-count');
            var oldCount = oldDrawer.querySelector('.cart-count');
            if (newCount && oldCount) {
              oldCount.innerHTML = newCount.innerHTML;
              console.log('[ShippingProgress] Cart count updated');
            }
          }
        }
        
        // Update cart icon bubble
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
            if (newBubble) {
              bubble.innerHTML = newBubble.innerHTML;
              console.log('[ShippingProgress] Cart icon bubble updated');
            }
          }
        }
        
        console.log('[ShippingProgress] All sections updated successfully');
        return sections;
      })
      .catch(function(error) { 
        console.log('[ShippingProgress] Error reloading sections:', error);
        location.reload(); 
      });
  }

  function runPendingCheck() {
    if (_pendingCheck) {
      _pendingCheck = false;
      setTimeout(checkCartAndUpdate, 150);
    }
  }

  function handleGiftLogic(cart) {
    if (_giftBusy) {
      _pendingCheck = true;
      return;
    }
    var totalWithoutGift = cartTotalWithoutGift(cart);
    var totalReais = totalWithoutGift / 100;
    var giftItem = findGiftInCart(cart);
    var meta2Reached = totalReais >= META2;
    
    // Count non-gift items to handle edge cases
    var nonGiftItemCount = 0;
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_id !== GIFT_PRODUCT_ID) {
          nonGiftItemCount++;
        }
      }
    }

    console.log('[ShippingProgress] Cart state:', {
      totalReais: totalReais,
      meta2Reached: meta2Reached,
      nonGiftItemCount: nonGiftItemCount,
      hasGift: !!giftItem,
      isAutomaticGift: giftItem ? isAutomaticGift(giftItem) : false
    });

    // Force remove gift if no regular products remain (only automatic gifts)
    if (nonGiftItemCount === 0 && giftItem && isAutomaticGift(giftItem)) {
      console.log('[ShippingProgress] Force removing automatic gift - no regular products');
      _giftBusy = true;
      removeGiftFromCart(giftItem.key).then(function() {
        console.log('[ShippingProgress] Automatic gift removed successfully, reloading page');
        // Force page reload for guaranteed UI update
        setTimeout(function() {
          location.reload();
        }, 500);
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { 
        console.log('[ShippingProgress] Error removing automatic gift');
        _giftBusy = false; 
        runPendingCheck(); 
      });
      return;
    }

    if (meta2Reached && !giftItem && nonGiftItemCount > 0) {
      _giftBusy = true;
      getGiftVariantId().then(function(variantId) {
        if (!variantId) { _giftBusy = false; runPendingCheck(); return; }
        return addGiftToCart(variantId).then(function() {
          return reloadCartSections();
        });
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (meta2Reached && giftItem && !isAutomaticGift(giftItem)) {
      _giftBusy = true;
      convertToAutomaticGift(giftItem.key, 1).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (meta2Reached && giftItem && giftItem.quantity > 1) {
      _giftBusy = true;
      setGiftQuantityTo1(giftItem.key).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    } else if (!meta2Reached && giftItem && isAutomaticGift(giftItem)) {
      console.log('[ShippingProgress] Removing gift - meta2 not reached');
      _giftBusy = true;
      removeGiftFromCart(giftItem.key).then(function() {
        return reloadCartSections();
      }).then(function() {
        _giftBusy = false;
        runPendingCheck();
      }).catch(function() { _giftBusy = false; runPendingCheck(); });
    }
  }

  function updateProgress(totalCents) {
    var wrappers = document.querySelectorAll('.shipping-progress-wrapper');
    if (wrappers.length === 0) return;

    var total = totalCents / 100;
    var percent = Math.min((total / META2) * 100, 100);
    var remaining1 = Math.max(META1 - total, 0);
    var remaining2 = Math.max(META2 - total, 0);
    var meta1Reached = total >= META1;
    var meta2Reached = total >= META2;

    wrappers.forEach(function(wrapper) {
      var fill = wrapper.querySelector('.shipping-progress__fill');
      if (fill) fill.style.width = percent + '%';

      var icons = wrapper.querySelectorAll('.shipping-progress__icon');
      if (icons[0]) icons[0].classList.toggle('is-reached', meta1Reached);
      if (icons[1]) icons[1].classList.toggle('is-reached', meta2Reached);

      var msg = wrapper.querySelector('.shipping-progress__message');
      if (msg) {
        if (meta2Reached) {
          msg.innerHTML = '<span>Parabéns! Você ganhou <strong>Frete Grátis</strong> e a <strong>Sacola de Praia</strong>!</span>';
        } else if (meta1Reached) {
          msg.innerHTML = '<span>Adicione mais <strong>R$&nbsp;' + formatBRL(remaining2) + '</strong> e receba a <strong>Sacola de Praia</strong>!</span>';
        } else {
          msg.innerHTML = '<span>Adicione mais <strong>R$&nbsp;' + formatBRL(remaining1) + '</strong> e receba <strong>Frete Grátis</strong>!</span>';
        }
      }
    });
  }

  function checkCartAndUpdate() {
    if (!_originalFetch) return;
    
    // Rate limiting to avoid connection verification issues
    var now = Date.now();
    if (now - _lastRequestTime < 2000) { // Minimum 2 seconds between requests
      console.log('[ShippingProgress] Request throttled to prevent rate limiting');
      return;
    }
    
    _lastRequestTime = now;
    _requestCount++;
    
    // Reset counter every minute
    if (_requestCount > _maxRequestsPerMinute) {
      console.log('[ShippingProgress] Rate limit reached, skipping request');
      return;
    }
    
    setTimeout(function() {
      _requestCount = Math.max(0, _requestCount - 1);
    }, 60000);
    
    _originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var totalWithoutGift = cartTotalWithoutGift(cart);
        updateProgress(totalWithoutGift);
        handleGiftLogic(cart);
      })
      .catch(function() {});
  }

  window.ShippingProgressCheckCart = checkCartAndUpdate;

  function debouncedCheck() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(checkCartAndUpdate, 1000);
  }

  document.addEventListener('cart:updated', debouncedCheck);
  document.addEventListener('cart:refresh', debouncedCheck);
  document.addEventListener('cart:change', debouncedCheck);
  
  // Override cart remove button functionality
  function overrideCartRemoveButtons() {
    var removeButtons = document.querySelectorAll('cart-remove-button, main-cart-remove-button');
    removeButtons.forEach(function(button) {
      if (!button.hasAttribute('data-gift-override')) {
        button.setAttribute('data-gift-override', 'true');
        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          
          console.log('[ShippingProgress] Cart remove button clicked with override');
          
          // Get the original click handler's data
          var index = this.dataset.index;
          var key = this.dataset.key;
          var embroideryId = this.dataset.embroideryId;
          
          // Call the original removal logic
          if (embroideryId) {
            // Handle embroidery items
            var escapedId = window.CSS && window.CSS.escape ? window.CSS.escape(embroideryId) : embroideryId.replace(/"/g, '\\"');
            var currentIndex = Number(index);
            var currentKey = key;
            var matchingButtons = Array.from(document.querySelectorAll('cart-remove-button[data-embroidery-id="' + escapedId + '"], main-cart-remove-button[data-embroidery-id="' + escapedId + '"]'));
            var items = [{
              key: currentKey,
              line: Number.isFinite(currentIndex) ? currentIndex : null,
            }, ...matchingButtons.map(function(btn) {
              return {
                key: btn.dataset.key,
                line: Number(btn.dataset.index),
              };
            })];
            
            if (items.some(function(item) { return item && item.key; })) {
              // Find the ProductForm instance and call updateQuantitiesByKey
              var productForm = button.closest('product-form') || document.querySelector('product-form');
              if (productForm && typeof productForm.updateQuantitiesByKey === 'function') {
                productForm.updateQuantitiesByKey(items, 0);
              }
            }
          } else {
            // Handle regular items
            var productForm = button.closest('product-form') || document.querySelector('product-form');
            if (productForm && typeof productForm.updateQuantity === 'function') {
              productForm.updateQuantity(index, 0);
            }
          }
          
          // Force gift check after removal with immediate removal logic
          setTimeout(function() {
            console.log('[ShippingProgress] Forcing gift check after removal');
            _originalFetch('/cart.js')
              .then(function(r) { return r.json(); })
              .then(function(cart) {
                console.log('[ShippingProgress] Cart after removal:', cart);
                var giftItem = findGiftInCart(cart);
                var nonGiftItemCount = 0;
                if (cart && cart.items) {
                  for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].product_id !== GIFT_PRODUCT_ID) {
                      nonGiftItemCount++;
                    }
                  }
                }
                
                console.log('[ShippingProgress] Non-gift items count:', nonGiftItemCount);
                console.log('[ShippingProgress] Gift item found:', !!giftItem);
                
                // If no regular products and automatic gift exists, remove it immediately
                if (nonGiftItemCount === 0 && giftItem && giftItem.properties && giftItem.properties._brinde_automatico === 'true') {
                  console.log('[ShippingProgress] IMMEDIATE AUTOMATIC GIFT REMOVAL - No regular products left');
                  _giftBusy = true;
                  _originalFetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: giftItem.key, quantity: 0 })
                  }).then(function(r) { return r.json(); })
                    .then(function() {
                      console.log('[ShippingProgress] Automatic gift removed successfully, reloading page');
                      // Direct page reload for guaranteed UI update
                      location.reload();
                    })
                    .catch(function(error) {
                      console.log('[ShippingProgress] Error removing automatic gift:', error);
                      _giftBusy = false;
                    });
                } else {
                  console.log('[ShippingProgress] Keeping gift - either manual gift or regular products exist');
                  checkCartAndUpdate();
                }
              })
              .catch(function(error) {
                console.log('[ShippingProgress] Error checking cart:', error);
              });
          }, 1500);
        });
      }
    });
  }
  
  // Run override immediately only
  overrideCartRemoveButtons();

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
      this.addEventListener('load', function() {
        var url = this._url || '';
        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1 ||
          url.indexOf('sections=') !== -1 ||
          url.indexOf('section_id=') !== -1
        ) {
          debouncedCheck();
        }
      });
      this._url = arguments[1];
      origOpen.apply(this, arguments);
    };
  }

  if (window.fetch) {
    window.fetch = function() {
      var args = arguments;
      return _originalFetch.apply(this, args).then(function(response) {
        var url = '';
        if (typeof args[0] === 'string') {
          url = args[0];
        } else if (args[0] && args[0].url) {
          url = args[0].url;
        }
        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1 ||
          url.indexOf('sections=') !== -1 ||
          url.indexOf('section_id=') !== -1
        ) {
          try {
            var clone = response.clone();
            clone.json().then(function() {
              debouncedCheck();
            }).catch(function() {
              debouncedCheck();
            });
          } catch(e) {
            debouncedCheck();
          }
        }
        return response;
      });
    };
  }

  getGiftVariantId();
  checkCartAndUpdate();

  // Manual trigger for debugging
  window.forceRemoveGift = function() {
    console.log('[ShippingProgress] Manual gift removal triggered');
    _originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        console.log('[ShippingProgress] Current cart:', cart);
        var giftItem = findGiftInCart(cart);
        if (giftItem) {
          console.log('[ShippingProgress] Found gift item:', giftItem);
          _giftBusy = true;
          removeGiftFromCart(giftItem.key).then(function() {
            console.log('[ShippingProgress] Gift removed manually');
            return reloadCartSections();
          }).then(function() {
            _giftBusy = false;
          }).catch(function(error) {
            console.log('[ShippingProgress] Error removing gift manually:', error);
            _giftBusy = false;
          });
        } else {
          console.log('[ShippingProgress] No gift found in cart');
        }
      })
      .catch(function(error) {
        console.log('[ShippingProgress] Error getting cart:', error);
      });
  };

  // Removed MutationObserver to prevent excessive requests

  console.log('[ShippingProgress] Script loaded globally from theme.liquid');
  console.log('[ShippingProgress] Manual trigger available: window.forceRemoveGift()');
})();
